import { routerMiddleware } from "connected-react-router/immutable";
import { fromJS } from "immutable";
import { applyMiddleware, compose, legacy_createStore as createStore } from "redux";
import thunk from "redux-thunk";

import * as companySessionActions from "@/components/new/CompanySession/company-session.actions";

import history from "../app/history";

import { loadState, saveState } from "./localStorage";
import { rootReducers } from "./root";

const enhancers = [];
const middleware = [thunk, routerMiddleware(history)];

if (process.env.NODE_ENV !== "production" || process.env.ENV === "staging4") {
  const devToolsExtension = window.__REDUX_DEVTOOLS_EXTENSION__;

  console.log(
    `NODE ENV - ${process.env.NODE_ENV} - CUSTOM ENV - ${process.env.ENV}. Enable dev tools extension`
  );

  if (typeof devToolsExtension === "function") {
    enhancers.push(devToolsExtension());
  }
}

const composedEnhancers = compose(applyMiddleware(...middleware), ...enhancers);

const persistedState = loadState();

const store = createStore(
  rootReducers,
  fromJS(persistedState),

  composedEnhancers
);

store.subscribe(() => {
  saveState({
    preferences: store.getState().get("preferences"),
  });
});

/** Purpose: Sync the company data from the customers module to the company session module */
/** This is needed because the company session module is not aware of the company data in the customers module */
/** Company Session Module is used for easier testing the company that used it */
let lastSyncedCompanySnapshot = null;
store.subscribe(() => {
  const state = store.getState();
  const customersCompany = state.getIn(["customers", "company"]);

  if (!customersCompany) {
    lastSyncedCompanySnapshot = null;
    return;
  }

  const companyJs =
    typeof customersCompany.toJS === "function" ? customersCompany.toJS() : customersCompany;
  const snapshot = JSON.stringify(companyJs);

  if (snapshot !== lastSyncedCompanySnapshot) {
    lastSyncedCompanySnapshot = snapshot;
    store.dispatch(companySessionActions.setCurrentCompany(companyJs));
  }
});

export default store;
